type IGTMWindow = Window & {
    dataLayer: object[];
};

class GTM {

    public static send(data: object) {
        if (window.hasOwnProperty("dataLayer")) {
            // tslint:disable-next-line:no-console
            console.debug("GTM: push to dataLayer...", data);

            (window as IGTMWindow).dataLayer.push(data);
        } else {
            // tslint:disable-next-line:no-console
            console.debug("GTM: dataLayer is undefined", data);
        }
    }
}

export {
    GTM,
};



// WEBPACK FOOTER //
// ./utilities/GTM.ts